module.exports = __webpack_public_path__ + "img/3_58.e6dadbf3.png";